import { useEffect, useState } from 'react';
import axios from 'axios';
import { Check, ChevronsUpDown, Store } from 'lucide-react';
import { Button } from '../../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../ui/command';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Çalışma alanı "mağaza listesi getir" ise lokasyondaki mağazalardan tek seçim
export const StorePicker = ({ locationId, value, onPick }) => {
  const [stores, setStores] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!locationId) return;
    axios.get(`${API}/firm/store-options`, { params: { location_id: locationId } }).then(r => setStores(r.data)).catch(() => setStores([]));
  }, [locationId]);
  const selected = stores.find(s => s.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="w-full justify-between font-normal" data-testid="wizard-store-select">
          <span className="flex items-center gap-2 truncate"><Store className="h-4 w-4 text-slate-500" />{selected ? `${selected.name}${selected.floor ? ` · ${selected.floor}` : ''}` : 'Mağaza/işletme seçin'}</span>
          <ChevronsUpDown className="h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Mağaza ara..." data-testid="wizard-store-search" />
          <CommandList>
            <CommandEmpty>Bu lokasyonda mağaza bulunamadı</CommandEmpty>
            <CommandGroup>
              {stores.map(s => (
                <CommandItem key={s.id} value={`${s.name} ${s.floor || ''}`} onSelect={() => { onPick(s); setOpen(false); }} data-testid={`wizard-store-option-${s.id}`}>
                  <Check className={`mr-2 h-4 w-4 ${s.id === value ? 'opacity-100' : 'opacity-0'}`} />
                  {s.name}{s.floor && <span className="ml-auto text-xs text-slate-400">{s.floor}</span>}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
